var DEFAULT_STATE = {
	page: 1,
	limit: 10,
	HotelMinPop: "10",
	HotelMaxPop: "50",
	HotelOrder: "",
	sort: "prlow",
	aroundmode: "0",
	isOpenedLayer: "",
	subLayer: "",
	hotelname: "",
	monthIndex: 0,
	calendarCount: {}
};

var DEF = {
	budget: [
		{name: "〜30,000円", code: "1"},
		{name: "30,001〜50,000円", code: "2"},
		{name: "50,001〜100,000円", code: "3"},
		{name: "100,001〜200,000円", code: "4"},
		{name: "200,001〜300,000円", code: "5"},
		{name: "300,001〜400,000円", code: "6"},
		{name: "400,001〜", code: "7"}
	],
	duration: [
		{name: "〜3日間", code: 1},
		{name: "4日間", code: 2},
		{name: "5日間", code: 3},
		{name: "6日間",  code: 4},
		{name: "7日間",  code: 5},
		{name: "8日間",  code: 6},
		{name: "9日間〜", code: 7}
	],
	reviewValues: [
		{value: "10", text: "評価 1.0"},
		{value: "15", text: "評価 1.5"},
		{value: "20", text: "評価 2.0"},
		{value: "25", text: "評価 2.5"},
		{value: "30", text: "評価 3.0"},
		{value: "35", text: "評価 3.5"},
		{value: "40", text: "評価 4.0"},
		{value: "45", text: "評価 4.5"},
		{value: "50", text: "評価 5.0"}
	]
};

var COOKIE = {
	HIST: {
		NAME: "JI_HIST",
		EXPIRES: 60, //day
		MAX_LENGTH: 5
	}
};

const RANKING_LIMIT = 3;
const REVIEW_HOTELS_PER_PAGE = 3;
const PAGE_WIDTH = 3;
const HOTEL_ORDER_ITEM_PER_PAGE = 5;

const NORMAL_PARAM = [
	"depAirport",
	"matrix",
	"date",
	"ym",
	"sort",
	"page",
	"keyword",
	"HotelMinPop",
	"HotelMaxPop",
	"HotelOrder",
	"region0",
	"country0",
	"city0",
	"country1",
	"city1",
	"onlyhere",
	"aroundmode",
	"Hotels",
	"ca",
	"checkStock",
	"ymCurrent",
	"ymNext",
	"jal_line",
	"NoReleaseDisp",
	"directOnly",
	"jrOnly"
];

// PCのコピー
const SP_PARAM = [
	{name:"SP_DEPT",title:"発地"},
	{name:"SP_AREA",title:"行き先方面"},
	{name:"SP_COUNTRY",title:"行き先国"},
	{name:"SP_CITY",title:"行き先都市"},
	{name:"SP_DATE",title:"出発日"},
	{name:"SP_MONTH",title:"出発月"},
	{name:"SP_PREFERENCE",title:"こだわり"},
	{name:"SP_KEYALL",title:"フリーキーワード"},
	{name:"SP_KEYHOTEL",title:"ホテルキーワード"},
	{name:"SP_KEYCNB",title:"コース番号"},
	{name:"SP_CTC",title:"カテゴリ"},
	{name:"SP_PAMPH",title:"パンフレット"},
	{name:"SP_BRAND",title:"客体"},
	{name:"SP_HOTEL",title:"宿泊ホテル"},
	{name:"SP_SALESDATE",title:"発売日"},
	{name:"SP_DURATION",title:"日数"},
	{name:"SP_DURATION_FT",title:"日数帯"},
	{name:"SP_RANGE",title:"価格帯"},
	{name:"SP_STOCKDATE",title:"在庫有り"},
	{name:"SP_STOCKDATE_RANGE",title:"在庫有り"}
];

const SP_NAMES = SP_PARAM.map((o) => (o.name));
const SP_NAMES_NOT = SP_NAMES.map((name) => (`${name}_NOT`));
const REQUEST_PARAM = NORMAL_PARAM.concat(["SPECIAL"], SP_NAMES, SP_NAMES_NOT);


const INTERNAL_STATE = [
	"depAirport",
	"duration",
	"budget",
	"date",
	"sort",
	"page",
	"freeword",
	"hotelname",
	"HotelMinPop",
	"HotelMaxPop",
	"HotelOrder",
	"region0",
	"country0",
	"city0",
	"country1",
	"city1",
	"_onlyhere",
	"aroundmode",
	"checkedHotel",
	"kodawari",
	"_checkStock"
];

const KODAWARI = [
	{selector: "#forcia-template-kodawari-flight", name: "フライト条件"},
	{selector: "#forcia-template-kodawari-hotelcond", name: "ホテル条件"},
	{selector: "#forcia-template-kodawari-hotellocation", name: "ホテル立地"},
	{selector: "#forcia-template-kodawari-roomtype", name: "部屋タイプ"},
	{selector: "#forcia-template-kodawari-tour", name: "ツアー内容"},
	{selector: "#forcia-template-kodawari-spot", name: "観光スポット"},
	{selector: "#forcia-template-kodawari-theme", name: "目的・テーマ"},
	{selector: "#forcia-template-kodawari-discount", name: "割引"},
	{selector: "#forcia-template-kodawari-others", name: "そのほか"}
];


const SORT = {
	prlow: {optionValue: "prlow", text:"価格の安い順"},
	prhigh: {optionValue: "prhigh", text:"価格の高い順"},
	arrival: {optionValue: "arrival", text:"新着順"},
	hotel: {optionValue: "hotel", text:"ホテル順"},
	hotel_back: {optionValue: "hotel_back", text:"ホテル順に戻る"}
};


export {
	DEFAULT_STATE,
	REQUEST_PARAM,
	INTERNAL_STATE,
	REVIEW_HOTELS_PER_PAGE,
	PAGE_WIDTH,
	RANKING_LIMIT,
	KODAWARI,
	DEF,
	COOKIE,
	HOTEL_ORDER_ITEM_PER_PAGE,
	SORT
};



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/search/config.js